// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activity-total-content .van-tabs__nav{background-color:rgba(33,37,39,.6)}.activity-total-content .van-tab{color:#efefef}.activity-total-content .van-tab--active{color:#fff}.activity-total-content .van-image__error,.activity-total-content .van-image__loading{background-color:rgba(33,37,39,.6)}", ""]);
// Exports
module.exports = exports;
